import { Font } from "@common/build/types";

const availableFonts: Font[] = [
    {
        name: "Poppins",
        url: "https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Roboto",
        url: "https://fonts.googleapis.com/css2?family=Roboto:wght@200;300;400;500;600;700;800&display=swap"
    },
    { name: "arial" },
    { name: "sans-serif" },
    { name: "Times New Roman" },
    {
        name: "Open Sans",
        url: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Lato",
        url: "https://fonts.googleapis.com/css2?family=Lato:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Montserrat",
        url: "https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Oswald",
        url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700;800&display=swap"
    },

    {
        name: "Noto Sans",
        url: "https://fonts.googleapis.com/css2?family=Noto+Sans:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Playfair Display",
        url: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Source Sans Pro",
        url: "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Merriweather",
        url: "https://fonts.googleapis.com/css2?family=Merriweather:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Nunito",
        url: "https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Raleway",
        url: "https://fonts.googleapis.com/css2?family=Raleway:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Ubuntu",
        url: "https://fonts.googleapis.com/css2?family=Ubuntu:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "PT Sans",
        url: "https://fonts.googleapis.com/css2?family=PT+Sans:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Roboto Slab",
        url: "https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Lora",
        url: "https://fonts.googleapis.com/css2?family=Lora:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Inconsolata",
        url: "https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Karla",
        url: "https://fonts.googleapis.com/css2?family=Karla:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Libre Baskerville",
        url: "https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "IBM Plex Sans",
        url: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Manrope",
        url: "https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Spectral",
        url: "https://fonts.googleapis.com/css2?family=Spectral:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "BioRhyme",
        url: "https://fonts.googleapis.com/css2?family=BioRhyme:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Archivo Narrow",
        url: "https://fonts.googleapis.com/css2?family=Archivo+Narrow:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Proza Libre",
        url: "https://fonts.googleapis.com/css2?family=Proza+Libre:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Chivo",
        url: "https://fonts.googleapis.com/css2?family=Chivo:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Neuton",
        url: "https://fonts.googleapis.com/css2?family=Neuton:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Mada",
        url: "https://fonts.googleapis.com/css2?family=Mada:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Rubik",
        url: "https://fonts.googleapis.com/css2?family=Rubik:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Rubik Vinyl",
        url: "https://fonts.googleapis.com/css2?family=Rubik+Vinyl&display=swap"
    },
    {
        name: "Rubik One",
        url: "https://fonts.googleapis.com/css2?family=Rubik+One&display=swap"
    },
    {
        name: "PT Serif",
        url: "https://fonts.googleapis.com/css2?family=PT+Serif:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Cardo",
        url: "https://fonts.googleapis.com/css2?family=Cardo:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Play",
        url: "https://fonts.googleapis.com/css2?family=Play:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Exo",
        url: "https://fonts.googleapis.com/css2?family=Exo:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Cinzel",
        url: "https://fonts.googleapis.com/css2?family=Cinzel:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Bitter",
        url: "https://fonts.googleapis.com/css2?family=Bitter:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Faustina",
        url: "https://fonts.googleapis.com/css2?family=Faustina:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Philosopher",
        url: "https://fonts.googleapis.com/css2?family=Philosopher:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Gelasio",
        url: "https://fonts.googleapis.com/css2?family=Gelasio:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Sofia Sans",
        url: "https://fonts.googleapis.com/css2?family=Sofia+Sans:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Actor",
        url: "https://fonts.googleapis.com/css2?family=Actor:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Epilogue",
        url: "https://fonts.googleapis.com/css2?family=Epilogue:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Glegoo",
        url: "https://fonts.googleapis.com/css2?family=Glegoo:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Yaldevi",
        url: "https://fonts.googleapis.com/css2?family=Yaldevi:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Overlock",
        url: "https://fonts.googleapis.com/css2?family=Overlock:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Lustria",
        url: "https://fonts.googleapis.com/css2?family=Lustria:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Ovo",
        url: "https://fonts.googleapis.com/css2?family=Ovo:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Suranna",
        url: "https://fonts.googleapis.com/css2?family=Suranna:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Overpass",
        url: "https://fonts.googleapis.com/css2?family=Overpass:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Assistant",
        url: "https://fonts.googleapis.com/css2?family=Assistant:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Tajawal",
        url: "https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Noto Sans Devanagari",
        url: "https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Inter",
        url: "https://fonts.googleapis.com/css2?family=Inter:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Qwitcher Grypen",
        url: "https://fonts.googleapis.com/css2?family=Qwitcher+Grypen:wght@200;300;400;500;600;700;800&display=swap"
    },
    {
        name: "Quattrocento",
        url: "https://fonts.googleapis.com/css2?family=Quattrocento:wght@200;300;400;500;600;700;800&display=swap"
    },
    { name: "inherit", url: "" }
];

export default availableFonts;
